module.exports = __webpack_public_path__ + "static/media/delishop_round_logo.b6f40219.png";